import React, {
    useContext,
    useCallback,
    useState,
    useEffect
} from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';

import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { ClausesUtil } from '@xengage/gw-policycommon-util-js';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import presentationMetadata from './CoverageComponent.metadata.json5';
import styles from './CoverageComponent.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function CoverageComponent(props) {
    const { authHeader } = useAuthentication();
    const [loadingClause, updateLoadingClause] = useState();
    const {
        wizardData: submissionVM, updateWizardData, isEditable = true, clausesBasePath, title, clasueType, pathToGet
    } = props;

    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { EndorsementService } = useDependencies('EndorsementService');
    const metadata = presentationMetadata["ProLinProduct.default.coverages"];
    const breakpoint = useContext(BreakpointTrackerContext);
    const {
        onValidate,
        registerComponentValidation,
        registerInitialComponentValidation
    } = useValidation('CoverageComponent');

    const changeSubmission = useCallback(
        (value, changedPath) => {
            _.set(submissionVM.value, 'errorsAndWarnings.validationIssues.issues', []);
            updateWizardData(
                ClausesUtil.setClauseValue(submissionVM, value, changedPath)
            );
        },
        [submissionVM, updateWizardData]
    );


    const syncCoverages = useCallback(async (value, changedPath) => {
        updateLoadingClause(true)
        
        const basePath = ClausesUtil.getObjectPathFromChangedPath(changedPath);
        let baseObject = _.get(submissionVM, basePath);
        const { jobType } = submissionVM.value.baseData;
        const jobService = jobType === 'PolicyChange' ? EndorsementService : LoadSaveService;
        const { quoteID, jobID, sessionUUID } = submissionVM.value;
        const lobName = ClausesUtil.getLobNameFromPath(clausesBasePath);

        if (!baseObject) {
            const escapedClausesBasePath = clausesBasePath.replace(/\[/g, '\\[').replace(/\]/g, '\\]');
            // eslint-disable-next-line no-secrets/no-secrets
            const clausesPath = changedPath.match(`${escapedClausesBasePath}.(errorsAndOmisionCoverages|cyberPrivacyBreachCoverageExtension|commercialGeneralLiability)`)[0];
            const baseObjectArray = _.get(submissionVM.value, clausesPath);
            const selectedBaseObject = baseObjectArray.filter((data) => data.updated === true);

            // eslint-disable-next-line prefer-destructuring
            baseObject = selectedBaseObject[0];
        }

        const clausesToUpdate = [clasueType].reduce((payloadToSend, clauseType) => {
            let clausePathValue = _.get(submissionVM, `${clausesBasePath}.value`);

            if (!clausePathValue) {
                clausePathValue = _.get(submissionVM.value, `${clausesBasePath}.${clauseType}`);
            }

            const clauses = clausePathValue || [];

            return _.merge(
                payloadToSend,
                ClausesUtil.structureClausesForServer(clauses, lobName, clauseType)
            );
        }, {});

        const res = await jobService.updateCoverages(quoteID || jobID, sessionUUID, clausesToUpdate, authHeader);// await updateClauses();
        const clausesBasePathTemp = clausesBasePath.indexOf('children') !== -1? clausesBasePath.replace('.children', ''):clausesBasePath
        const updatedCov = _.get(res, pathToGet)
        
        _.set(submissionVM.value, clausesBasePathTemp, updatedCov)
        
        updateLoadingClause(false)
        updateWizardData(submissionVM);

    }, [submissionVM, EndorsementService, LoadSaveService, clausesBasePath, clasueType, authHeader, pathToGet, updateWizardData]);


    const changeSubmissionAndSync = useCallback(
        (value, changedPath) => {
            changeSubmission(value, changedPath);
            syncCoverages(value, changedPath);
        },
        [changeSubmission, syncCoverages]
    );

    const resolvers = {
        resolveCallbackMap: {
            onChangeClause: changeSubmission,
            onSyncCoverages: syncCoverages,
            onChangeSubmissionAndSync: changeSubmissionAndSync,
            onValidate,
        },
        resolveClassNameMap: styles
    };

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        coverages: {
            loadingClause,
            path: `${clausesBasePath}`,
            isEditable,
            value: _.get(submissionVM, `${clausesBasePath}.value`)
        },
        coverageAccordionDetails: {
            title
        }
    };

    const isPageLoading = useCallback(() => _.isUndefined(loadingClause), [loadingClause]);

    useEffect(() => {
        registerComponentValidation(isPageLoading);
    }, [
        isPageLoading,
        registerComponentValidation,
        registerInitialComponentValidation
    ]);

    return (
        <ViewModelForm
            uiProps={metadata.content}
            model={submissionVM}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onModelChange={updateWizardData}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

CoverageComponent.propTypes = {
    ...wizardProps
};

export default CoverageComponent;
